<div class="price-table">
  <div class="price-table-header">
    <div class="header-cell">Aantal</div>
    <div class="header-cell">Prijs (st)</div>
    <div class="header-cell">Kapvorm (st)</div>
    <div class="header-cell">Aflopend (st)</div>
    <div class="header-cell">Reflec (st)</div>
    <div class="empty-header-cell"></div>
  </div>

  <div
    class="price-table-row"
    *ngFor="let bulkPrice of bulkPrices; let i = index"
  >
    <div>
      <input
        type="number"
        [ngModel]="bulkPrice.bulkNumber"
        (blur)="onInputBlur(i, 'bulkNumber', $event.target.value)"
      />
    </div>
    <div class="euro-input">
      <span>€</span
      ><input
        type="number"
        [ngModel]="bulkPrice.unitPrice | number : '1.2-2'"
        (blur)="onInputBlur(i, 'unitPrice', $event.target.value)"
      />
    </div>
    <div class="euro-input">
      <span>€</span
      ><input
        type="number"
        [ngModel]="bulkPrice.capShape | number : '1.2-2'"
        (blur)="onInputBlur(i, 'capShape', $event.target.value)"
      />
    </div>
    <div class="euro-input">
      <span>€</span
      ><input
        type="number"
        [ngModel]="bulkPrice.descending | number : '1.2-2'"
        (blur)="onInputBlur(i, 'descending', $event.target.value)"
      />
    </div>
    <div class="euro-input">
      <span>€</span
      ><input
        type="number"
        [ngModel]="bulkPrice.reflecting | number : '1.2-2'"
        (blur)="onInputBlur(i, 'reflecting', $event.target.value)"
      />
    </div>
    <div>
      <button class="delete-btn" (click)="deleteRow(bulkPrice.bulkNumber)">
        X
      </button>
    </div>
  </div>

  <button class="add-row-btn" (click)="addRow()">+</button>
</div>
